import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import SiAutocomplete from "../../core/si-autocomplete";
import { Typography } from "@mui/material";
// import CustomPieChart from "./pi-chart"; // If you're using a custom chart

const COLORS = [
  "#faa264",
  "#74fcbf",
  "#74c3fc",
  "#fc74c1",
  "#8884d8",
  "#82ca9d",
  "#ffc658",
  "#ff7f50",
  "#a4de6c",
  "#ffbb28",
  "#ff8042",
  "#00C49F",
  "#FF6384",
  "#36A2EB",
];

const FaultPieChartContainer = ({ dataMap }) => {
  const [selected, setSelected] = useState(null);
  const [defectList, setDefectList] = useState([]);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const total = context.dataset.data.reduce(
              (sum, val) => sum + val,
              0
            );
            const value = context.parsed;
            const percentage = ((value / total) * 100).toFixed(1);

            const label = context.label || "";
            const valueStr = `Value: ${value}`;
            const percentStr = `(${percentage}%)`;

            // Split long label if needed, or just return as separate lines
            return [`${label}`, valueStr, percentStr];
          },
        },
      },
    },
  };

  useEffect(() => {
    const entries = Object.values(dataMap || {});
    const companyMap = entries.reduce((acc, companies) => {
      for (const [company, count] of Object.entries(companies)) {
        acc[company] = (acc[company] || 0) + count;
      }
      return acc;
    }, {});

    const labels = Object.keys(companyMap);
    const values = Object.values(companyMap);

    setChartData({
      labels,
      datasets: [
        {
          data: values,
          backgroundColor: labels.map((_, idx) => COLORS[idx % COLORS.length]),
          borderWidth: 1,
        },
      ],
    });
  }, [dataMap]);

  return (
    <div>
      {/* <SiAutocomplete
        options={defectList}
        value={selected}
        onChange={(val) => handleSelect(val)}
        label="Select Defect Type"
        fullWidth
      /> */}

      <Doughnut data={chartData} options={options} height={100} />
    </div>
  );
};

export default FaultPieChartContainer;
